import React from "react";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { Grid, Typography } from "@mui/material";
import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { EmployeePresenceAndLeavesSummaryDTO } from "../../../../models/employee-presence-and-leaves-summary/employee-presence-and-leaves-summary-dto";

const MyTimesheetLinkAsFooter = ({
  customSummary,
  loading,
}: {
  customSummary?: EmployeePresenceAndLeavesSummaryDTO;
  loading: boolean;
}) => {
  const { t } = useTranslation();
  const tRP = "components.custom_widget_link_footers.my_presence_and_leaves";
  const theme = useTheme();
  return (
    <>
      {Number(customSummary?.timesheetAnomalies) > 0 && !loading ? (
        <Grid style={{ display: "flex", alignItems: "center", gap: "5px" }}>
          <FontAwesomeIcon
            icon={faCircleExclamation}
            color={theme.palette.error.main}
          />
          <Typography color={theme.palette.error.main}>{`${t(`${tRP}.anomalies`)}`}</Typography>
        </Grid>
      ) : (
        <></>
      )}
    </>
  );
};
export default MyTimesheetLinkAsFooter;
